import { inject, Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { DfEventService } from '@df/core/service/df-event';

@Injectable({
    providedIn: 'root'
})
export class CustomerTokenService {
    private requestService = inject(RequestService);
    private dfEventsService = inject(DfEventService);
    /**
     * Auth token
     */
    private authToken?: { token: string; valid: number };

    constructor() {
        this.dfEventsService.success(event => {
            if (event.id === 'customerDataChange') {
                if (!event.data.logged) {
                    this.authToken = undefined;
                }
            }
        });
    }

    /**
     * Token generator
     */
    async retrieveToken(): Promise<string> {
        if (!this.authToken || this.authToken.valid < Date.now()) {
            this.authToken = await this.requestService.sendXHR<{
                token: string; // token value
                valid: number; // timestamp
            }>('customer/token', {});
        }
        return this.authToken!.token;
    }
}
